// import React, { useState, useEffect } from 'react';
// import { useDropzone } from 'react-dropzone';
// import Card from 'react-bootstrap/Card';
// import Button from 'react-bootstrap/Button';
// import Form from 'react-bootstrap/Form';
// import axios from 'axios';
// import Navbar from '../../Components/Navbar'; 
// import './UploadFiles.css';
// import DownloadIcon from "@mui/icons-material/Download";
// import { useNavigate } from 'react-router-dom';
// import { API_BASE_URL } from '../../config';


// function Budget() {
//   const [appData, setAppData] = useState([]);
//   const [selectedAppId, setSelectedAppId] = useState("");
//   const [selectedProjectTitle, setSelectedProjectTitle] = useState("");
//   //const [acceptedFiles1, setAcceptedFiles1] = useState([]);
//   const [acceptedFiles2, setAcceptedFiles2] = useState([]);
//   const [errors, setErrors] = useState({});
//   const [submitted, setSubmitted] = useState(false);
//   const navigate = useNavigate();
  

//   useEffect(() => {
//     axios.get(`${API_BASE_URL}/GetApplicationID.php`)
//       .then(response => {
//         console.log("Fetched Data:", response.data); // Log the fetched data
//         if (Array.isArray(response.data)) {
//           setAppData(response.data);
//         } else {
//           console.error('Invalid data format, expected an array');
//         }
//       })
//       .catch(error => console.error('Error fetching app_IDs and project titles:', error));
//   }, []);
  

//   useEffect(() => {
//     console.log("appData:", appData); // Ensure appData is populated
//     console.log("selectedAppId:", selectedAppId); // Ensure selectedAppId is valid
  
//     const selectedApp = appData.find(item => item.app_ID === parseInt(selectedAppId, 10));  // If app_ID is a number
// console.log("Selected App:", selectedApp);
//     // Set the project title if a matching app is found
//     if (selectedApp) {
//       setSelectedProjectTitle(selectedApp.projectTitle);
//       console.log("Selected Project Title:", selectedApp.projectTitle); // Log before setting state
//     } else {
//       setSelectedProjectTitle("");
//       console.log("No matching project title found for app_ID:", selectedAppId); // Log when no match found
//     }
//   }, [selectedAppId, appData]);
  
//   useEffect(() => {
//     console.log("Selected Project Title (Updated):", selectedProjectTitle); // Log whenever title updates
//   }, [selectedProjectTitle]);
  
  

//   // const { getRootProps: getRootProps1, getInputProps: getInputProps1 } = useDropzone({
//   //   onDrop: acceptedFiles => setAcceptedFiles1(acceptedFiles),
//   // });

//   const { getRootProps: getRootProps2, getInputProps: getInputProps2 } = useDropzone({
//     onDrop: acceptedFiles => setAcceptedFiles2(acceptedFiles),
//   });

//   const validateFiles = () => {
//     const newErrors = {};
//     if (!selectedAppId) newErrors.appId = 'Please select an application ID';
//     // if (acceptedFiles1.length === 0) newErrors.PreviousBudget = 'Previous Budget Revision file is required';
//     if (acceptedFiles2.length === 0) newErrors.CurrentBudget = 'Current Budget Revision file is required';
//     return newErrors;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const validationErrors = validateFiles();
//     if (Object.keys(validationErrors).length > 0) {
//       setErrors(validationErrors);
//       return;
//     }

//     const formData = new FormData();
//     formData.append('app_ID', selectedAppId);
//     formData.append('project_title', selectedProjectTitle);
//    // acceptedFiles1.forEach(file => formData.append('PreviousBudget', file));
//     acceptedFiles2.forEach(file => formData.append('CurrentBudget', file));

//     try {
//       const response = await axios.post(`${API_BASE_URL}/Budget.php`, formData, {
//         headers: {
//           'Content-Type': 'multipart/form-data',
//         },
//       });
//       console.log('Success:', response.data);
//       setSubmitted(true);
//       // Clear the form after successful submission
//       /*setAcceptedFiles1([]);*/
//       setAcceptedFiles2([]);
//       setErrors({});
//       // Navigate to the Popup page
//       navigate('/popup');
//     } catch (error) {
//       console.error('Error:', error);
//       alert('Error uploading files.');
//     }
//   };

//   return (
    
//     <div>
//       <Navbar />

//        {/* Download Template Section */}
//        <div className="template-download-section">
//         <p>
//           <strong className='downloadtitle'>Download the Template:</strong>
//           <a 
//             href="/Templates/Budget Revisions.docx" 
//             download = "Budget Revisions.docx"
//             className="template-link"
            
//           >
//            Budget Template
//            <DownloadIcon style={{ fontSize: "1.5rem", marginRight: "0.5rem" }} />

//           </a>
//         </p>
//       </div>
     
//       <label className='uploadtitle'>Upload Previous and Current Budget Here 👇</label>

// <Form.Group controlId="projectTitleSelect">
//         <Form.Label className='selecttitle'>Select Application ID:</Form.Label>
//       <Form.Control
//   className="appid_dropdown"
//   as="select"
//   value={selectedAppId}
//   onChange={(e) => {
//     const selectedId = e.target.value;
//     console.log("Selected App ID:", selectedId); // Log the selected ID
//     setSelectedAppId(selectedId);
//   }}
// >
//   <option value="">-- Select Application ID --</option>
//   {appData.map((item) => (
//     <option key={item.app_ID} value={item.app_ID}>
//       {item.app_ID}
//     </option>
//   ))}
// </Form.Control>

// </Form.Group>

//       <Form.Group controlId="projectTitleSelect">
//         <Form.Label className='selecttitle'>Project Title:</Form.Label>
//         <Form.Control
//           className="project_dropdown"
//           type="text"
//           value={selectedProjectTitle}
//           readOnly
//         />
//       </Form.Group>
     
//       {/* <div className="label-container1">
//         <Form.Label>1. Upload Previous Budget</Form.Label>
//         {errors.PreviousBudget && <p className="error">{errors.PreviousBudget}</p>}
//       </div>
//       <Card className="dropzone-container">
//         <div {...getRootProps1({ className: 'dropzone' })}>
//           <input {...getInputProps1()} />
//           <p>Drag & drop file here, or click to select file</p>
         
//           <Button variant="primary" className='browsefiles'>Browse Files</Button>
//         </div>
//         <aside>
//           <h6>Files:</h6>
//           <ul>
//             {acceptedFiles1.map(file => (
//               <li key={file.path}>{file.path} - {file.size} bytes</li>
//             ))}
//           </ul>
//         </aside>
//       </Card> */}

//       <div className="label-container2">
//         <Form.Label>Upload Current Budget</Form.Label>
//         {errors.CurrentBudget && <p className="error">{errors.CurrentBudget}</p>}
//       </div>
//       <Card className="dropzone-container">
//         <div {...getRootProps2({ className: 'dropzone' })}>
//           <input {...getInputProps2()} />
//           <p>Drag & drop file here, or click to select file</p>
         
//           <Button variant="primary">Browse Files</Button>
//         </div>
//         <aside>
//           <h6>Files:</h6>
//           <ul>
//             {acceptedFiles2.map(file => (
//               <li key={file.path}>{file.path} - {file.size} bytes</li>
//             ))}
//           </ul>
//         </aside>
//       </Card>

//       <Button variant="success" onClick={handleSubmit} className='submitbutton'>Submit</Button>
//     </div>
//   );
// }

// export default Budget;
import React, { useState, useEffect } from 'react';
import { useDropzone } from 'react-dropzone';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import axios from 'axios';
import Navbar from '../../Components/Navbar';
import './UploadFiles.css';
import DownloadIcon from "@mui/icons-material/Download";
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../../config';

function Budget() {
  const [appData, setAppData] = useState([]);
  const [selectedAppId, setSelectedAppId] = useState("");
  const [selectedProjectTitle, setSelectedProjectTitle] = useState("");
  const [acceptedFiles2, setAcceptedFiles2] = useState([]);
  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    axios.get(`${API_BASE_URL}/GetApplicationID.php`)
      .then(response => {
        if (Array.isArray(response.data)) {
          setAppData(response.data);
        }
      })
      .catch(error => console.error('Error fetching app_IDs and project titles:', error));
  }, []);

  useEffect(() => {
    const selectedApp = appData.find(item => item.app_ID === parseInt(selectedAppId, 10));
    if (selectedApp) {
      setSelectedProjectTitle(selectedApp.projectTitle);
    } else {
      setSelectedProjectTitle("");
    }
  }, [selectedAppId, appData]);

  const { getRootProps: getRootProps2, getInputProps: getInputProps2 } = useDropzone({
    onDrop: acceptedFiles => setAcceptedFiles2(acceptedFiles),
  });

  const validateFiles = () => {
    const newErrors = {};
    if (!selectedAppId) newErrors.appId = 'Please select an application ID';
    if (acceptedFiles2.length === 0) newErrors.CurrentBudget = 'Current Budget Revision file is required';
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validateFiles();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    const formData = new FormData();
    formData.append('app_ID', selectedAppId);
    formData.append('project_title', selectedProjectTitle);
    acceptedFiles2.forEach(file => formData.append('CurrentBudget', file));

    try {
      const response = await axios.post(`${API_BASE_URL}/Budget.php`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      setSubmitted(true);
      setAcceptedFiles2([]);
      setErrors({});
      navigate('/popup');
    } catch (error) {
      console.error('Error:', error);
      alert('Error uploading files.');
    }
  };

  return (
    <div>
      <Navbar />

      {/* Three-column White Box Layout */}
      <div className="budget-upload-box">
        {/* Left Column - Download Template */}
        <div className="budget-column">
          <p>
            <span className="downloadtitle">Download the Template:</span>
            <a
              href="/Templates/Budget Revisions.docx"
              download="Budget Revisions.docx"
              className="template-link"
            >
              Budget Template
              <DownloadIcon style={{ fontSize: "1.5rem", marginLeft: "0.5rem" }} />
            </a>
          </p>
        </div>

        {/* Middle Column - Select Application ID */}
        <div className="budget-column">
          <Form.Group controlId="appIdSelect">
            <Form.Label className="selecttitle">Select Application ID:</Form.Label>
            <Form.Control
              className="appid_dropdown"
              as="select"
              value={selectedAppId}
              onChange={(e) => setSelectedAppId(e.target.value)}
            >
              <option value="">-- Select Application ID --</option>
              {appData.map((item) => (
                <option key={item.app_ID} value={item.app_ID}>
                  {item.app_ID}
                </option>
              ))}
            </Form.Control>
          </Form.Group>
        </div>

        {/* Right Column - Project Title */}
        <div className="budget-column">
          <Form.Group controlId="projectTitleDisplay">
            <Form.Label className="selecttitle">Project Title:</Form.Label>
            <Form.Control
              className="project_dropdown"
              type="text"
              value={selectedProjectTitle}
              readOnly
            />
          </Form.Group>
        </div>
      </div>

      {/* File Upload Section */}
      <label className='uploadtitle'>Upload Current Budget Here 👇</label>

      <div className="label-container2">
        
        
        {errors.CurrentBudget && <p className="error">{errors.CurrentBudget}</p>}
      </div>

      <Card className="dropzone-container">
        <div {...getRootProps2({ className: 'dropzone' })}>
          <input {...getInputProps2()} />
          <p>Drag & drop file here, or click to select file</p>
          <Button variant="primary">Browse Files</Button>
        </div>
        <aside>
          <h6>Files:</h6>
          <ul>
            {acceptedFiles2.map(file => (
              <li key={file.path}>{file.path} - {file.size} bytes</li>
            ))}
          </ul>
        </aside>
      </Card>

      <Button variant="success" onClick={handleSubmit} className='submitbutton'>Submit</Button>
    </div>
  );
}

export default Budget;
